module.exports = __webpack_public_path__ + "static/img/17.56af2b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/17.png
// module id = MA4/
// module chunks = 0